import { FunctionField } from "react-admin";

export const AddressField = (props) => {
    return (
        <FunctionField
            {...props}
            source="address"
            render={(record) =>
                `${record.address.address1 || ""} ${
                    record.address.address2 || ""
                } ${record.address.address3 || ""}`
            }
        />
    );
};
